var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 20V4H9.64844V20H5ZM14.3516 4H19V20H14.3516V4Z","fill":"black"}));
}

Pause.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
